import { useRouter } from 'next/router';
import * as React from 'react';

import { homeURL } from '@/utils/router';

interface LogoIconProps extends React.SVGProps<SVGElement> {
  collapsed?: boolean;
  sidebarWidth?: number;
}

const LogoIcon: React.FC<LogoIconProps> = ({ collapsed = false, sidebarWidth = 222 }) => {
  const router = useRouter();

  const handleLogoClick = () => {
    router.push(homeURL);
  };
  return (
    <div
      className={`fixed top-0 z-10 flex min-h-[56px] p-[16px] shrink-0 cursor-pointer bg-app-panel text-app-primary transition-[width,padding] duration-200 ease-out ${
        collapsed
          ? 'flex-col items-center justify-center gap-[4px] px-0'
          : 'items-center  pl-[24px]'
      }`}
      style={{ width: sidebarWidth, background: '#161616' }}
      onClick={handleLogoClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M9.32608 9.17214C9.32608 6.3867 11.5841 4.12866 14.3696 4.12866H29.5C29.5 6.9141 27.242 9.17214 24.4565 9.17214H9.32608Z"
          fill="url(#paint0_linear_5075_52089)"
        />
        <path
          d="M0.5 16.1069C0.5 13.3215 2.75804 11.0634 5.54348 11.0634H20.6739C20.6739 13.8489 18.4159 16.1069 15.6304 16.1069H0.5Z"
          fill="url(#paint1_linear_5075_52089)"
        />
        <path
          d="M11.2978 21.9884C10.6563 24.699 7.93904 26.3761 5.2285 25.7345L7.05956 17.9982H12.2422L11.2978 21.9884Z"
          fill="url(#paint2_linear_5075_52089)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5075_52089"
            x1="6.61392"
            y1="25.5173"
            x2="24.3434"
            y2="11.273"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8F49FF" />
            <stop offset="1" stopColor="#3CC2FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5075_52089"
            x1="6.61392"
            y1="25.5173"
            x2="24.3434"
            y2="11.273"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8F49FF" />
            <stop offset="1" stopColor="#3CC2FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5075_52089"
            x1="6.61392"
            y1="25.5173"
            x2="24.3434"
            y2="11.273"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8F49FF" />
            <stop offset="1" stopColor="#3CC2FF" />
          </linearGradient>
        </defs>
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="65"
        height="12"
        viewBox="0 0 65 12"
        fill="none"
        style={{
          transform: `scale(${collapsed ? 1 : 1.2})`,
          marginLeft: collapsed ? '0' : '20px',
        }}
      >
        <path
          d="M61.0324 11.7573V0.634277H63.1627V11.7573H61.0324ZM59.1948 5.77297V3.90287H65.0002V5.77297H59.1948Z"
          fill="currentColor"
        />
        <path
          d="M54.555 11.9198C53.8611 11.9198 53.2432 11.7735 52.7011 11.4808C52.1699 11.1881 51.7525 10.7815 51.449 10.2611C51.1454 9.74077 50.9937 9.13909 50.9937 8.4561V3.90283H53.1402V8.40732C53.1402 8.73255 53.1944 9.01442 53.3028 9.25292C53.4112 9.48059 53.5738 9.65404 53.7907 9.7733C54.0075 9.89255 54.2622 9.95218 54.555 9.95218C54.9994 9.95218 55.3464 9.81666 55.5957 9.54563C55.845 9.27461 55.9697 8.89517 55.9697 8.40732V3.90283H58.1V8.4561C58.1 9.14993 57.9482 9.75703 57.6447 10.2774C57.352 10.7978 56.9346 11.2043 56.3925 11.497C55.8613 11.7789 55.2488 11.9198 54.555 11.9198Z"
          fill="currentColor"
        />
        <path
          d="M45.5047 11.9199C44.67 11.9199 43.8948 11.7736 43.1793 11.4809C42.4638 11.1773 41.835 10.7599 41.293 10.2287C40.7618 9.68667 40.3498 9.05788 40.0571 8.34237C39.7752 7.62686 39.6343 6.85714 39.6343 6.03321C39.6343 5.20929 39.7752 4.43957 40.0571 3.72405C40.3498 3.00854 40.7618 2.38518 41.293 1.85396C41.835 1.32275 42.4584 0.905362 43.1631 0.601811C43.8786 0.29826 44.6591 0.146484 45.5047 0.146484C46.4154 0.146484 47.2176 0.29826 47.9115 0.601811C48.6053 0.894521 49.2178 1.30106 49.749 1.82144L48.253 3.31751C47.9386 2.9706 47.5537 2.69957 47.0984 2.50443C46.6431 2.30929 46.1118 2.21172 45.5047 2.21172C44.9735 2.21172 44.4857 2.30387 44.0412 2.48817C43.6075 2.66162 43.2281 2.92181 42.9029 3.26873C42.5776 3.6048 42.3283 4.01134 42.1548 4.48835C41.9814 4.95452 41.8946 5.46947 41.8946 6.03321C41.8946 6.60779 41.9814 7.12816 42.1548 7.59433C42.3283 8.0605 42.5776 8.46704 42.9029 8.81396C43.2281 9.15003 43.6075 9.41022 44.0412 9.59452C44.4857 9.77882 44.9735 9.87097 45.5047 9.87097C46.1444 9.87097 46.6918 9.7734 47.1472 9.57826C47.6133 9.38312 48.0036 9.10667 48.318 8.74891L49.8141 10.245C49.2829 10.7762 48.6649 11.1882 47.9603 11.4809C47.2556 11.7736 46.4371 11.9199 45.5047 11.9199Z"
          fill="currentColor"
        />
        <path
          d="M34.3273 11.9198C33.5359 11.9198 32.8203 11.7409 32.1807 11.3831C31.5519 11.0145 31.0478 10.5213 30.6684 9.90331C30.2998 9.27453 30.1155 8.57528 30.1155 7.80556C30.1155 7.03584 30.2998 6.34743 30.6684 5.74032C31.037 5.12238 31.5411 4.63453 32.1807 4.27677C32.8203 3.90818 33.5304 3.72388 34.311 3.72388C35.1132 3.72388 35.8287 3.90818 36.4575 4.27677C37.0972 4.63453 37.6013 5.12238 37.9699 5.74032C38.3385 6.34743 38.5228 7.03584 38.5228 7.80556C38.5228 8.57528 38.3385 9.27453 37.9699 9.90331C37.6013 10.5213 37.0972 11.0145 36.4575 11.3831C35.8287 11.7409 35.1187 11.9198 34.3273 11.9198ZM34.311 9.93584C34.7121 9.93584 35.0644 9.84911 35.368 9.67565C35.6824 9.49135 35.9209 9.242 36.0835 8.92761C36.257 8.60238 36.3437 8.23378 36.3437 7.82182C36.3437 7.40986 36.257 7.04668 36.0835 6.73229C35.9101 6.41789 35.6715 6.17397 35.368 6.00051C35.0644 5.81621 34.7121 5.72406 34.311 5.72406C33.9207 5.72406 33.5738 5.81621 33.2702 6.00051C32.9667 6.17397 32.7282 6.41789 32.5547 6.73229C32.3813 7.04668 32.2945 7.40986 32.2945 7.82182C32.2945 8.23378 32.3813 8.60238 32.5547 8.92761C32.7282 9.242 32.9667 9.49135 33.2702 9.67565C33.5738 9.84911 33.9207 9.93584 34.311 9.93584Z"
          fill="currentColor"
        />
        <path
          d="M26.4334 11.9198C25.6311 11.9198 24.9102 11.7409 24.2706 11.3831C23.6309 11.0254 23.1268 10.5375 22.7582 9.91957C22.3896 9.30163 22.2053 8.6078 22.2053 7.83808C22.2053 7.05752 22.3896 6.35827 22.7582 5.74032C23.1268 5.12238 23.6309 4.63453 24.2706 4.27677C24.921 3.90818 25.642 3.72388 26.4334 3.72388C27.0513 3.72388 27.6205 3.83771 28.1408 4.06537C28.6612 4.29304 29.1111 4.61827 29.4906 5.04107L28.1246 6.42331C27.9186 6.19565 27.6692 6.02219 27.3765 5.90294C27.0947 5.78369 26.7803 5.72406 26.4334 5.72406C26.0431 5.72406 25.6907 5.81621 25.3764 6.00051C25.0728 6.17397 24.8289 6.41789 24.6446 6.73229C24.4711 7.03584 24.3844 7.39902 24.3844 7.82182C24.3844 8.23378 24.4711 8.60238 24.6446 8.92761C24.8289 9.242 25.0728 9.49135 25.3764 9.67565C25.6907 9.84911 26.0431 9.93584 26.4334 9.93584C26.7911 9.93584 27.1109 9.87621 27.3928 9.75696C27.6855 9.62686 27.9349 9.44257 28.1408 9.20406L29.5231 10.5863C29.122 11.0199 28.6612 11.3506 28.1408 11.5783C27.6205 11.8059 27.0513 11.9198 26.4334 11.9198Z"
          fill="currentColor"
        />
        <path d="M18.6267 11.7572V0H20.757V11.7572H18.6267Z" fill="currentColor" />
        <path
          d="M12.2698 11.9199C11.5543 11.9199 10.9092 11.741 10.3346 11.3832C9.76006 11.0255 9.31015 10.5376 8.98492 9.91967C8.65969 9.30173 8.49707 8.6079 8.49707 7.83818C8.49707 7.05762 8.65969 6.35836 8.98492 5.74042C9.31015 5.12248 9.76006 4.63463 10.3346 4.27687C10.9092 3.91911 11.5543 3.74023 12.2698 3.74023C12.8335 3.74023 13.3376 3.85407 13.7821 4.08173C14.2266 4.30939 14.5789 4.62921 14.8391 5.04117C15.1102 5.44229 15.2565 5.89762 15.2782 6.40715V9.23668C15.2565 9.75705 15.1102 10.2178 14.8391 10.6189C14.5789 11.02 14.2266 11.3399 13.7821 11.5784C13.3376 11.806 12.8335 11.9199 12.2698 11.9199ZM12.6601 9.9522C13.2563 9.9522 13.7388 9.75705 14.1073 9.36677C14.4759 8.96565 14.6602 8.4507 14.6602 7.82192C14.6602 7.40995 14.5735 7.04678 14.4001 6.73238C14.2374 6.40715 14.0044 6.1578 13.7008 5.98435C13.4081 5.80005 13.0612 5.7079 12.6601 5.7079C12.2698 5.7079 11.9229 5.80005 11.6193 5.98435C11.3266 6.1578 11.0935 6.40715 10.9201 6.73238C10.7574 7.04678 10.6761 7.40995 10.6761 7.82192C10.6761 8.24472 10.7574 8.61874 10.9201 8.94397C11.0935 9.25836 11.3266 9.50771 11.6193 9.69201C11.9229 9.86547 12.2698 9.9522 12.6601 9.9522ZM14.5464 11.7572V9.64322L14.8879 7.72435L14.5464 5.83799V3.90285H16.6604V11.7572H14.5464Z"
          fill="currentColor"
        />
        <path
          d="M0 11.7572V0.325195H2.21159V11.7572H0ZM1.62617 7.07379V5.10613H7.3828V7.07379H1.62617ZM1.62617 2.2766V0.325195H7.65925V2.2766H1.62617Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export default React.memo(LogoIcon);
